"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroupItemLabel = exports.RadioGroupItemCheckbox = exports.RadioGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Wrap the entire Radio Group in this component.
 * This will make sure that all the radio buttons are linked using the role="radiogroup"
 */
function RadioGroup({ as: Tag = "section", children, ...restProps }) {
    return ((0, jsx_runtime_1.jsx)(Tag, { role: "radiogroup", ...restProps, children: children }));
}
exports.RadioGroup = RadioGroup;
/**
 * Use this to wrap the radio button itself.
 */
function RadioGroupItemCheckbox({ value, selected, checkMarkEl, ...restProps }) {
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", role: "radio", "aria-checked": selected, tabIndex: -1, id: value, value: value, ...restProps, children: selected ? checkMarkEl : null }));
}
exports.RadioGroupItemCheckbox = RadioGroupItemCheckbox;
/**
 * Use this to wrap the label for each radio button.
 */
function RadioGroupItemLabel({ value, children, ...restProps }) {
    return ((0, jsx_runtime_1.jsx)("label", { htmlFor: value, ...restProps, children: children }));
}
exports.RadioGroupItemLabel = RadioGroupItemLabel;
//# sourceMappingURL=index.js.map